module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('h1', [_vm._v("Let’s discuss your next interactive project.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.errors.includes('name')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.name),
      expression: "message.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.message.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.errors.includes('email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.email),
      expression: "message.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.message.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.errors.includes('subject')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.subject),
      expression: "message.subject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Subject",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.message.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message.subject = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.errors.includes('message')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.message),
      expression: "message.message"
    }],
    staticClass: "form-control",
    attrs: {
      "cols": "25",
      "rows": "10",
      "placeholder": "Message",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.message.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit",
      "disabled": _vm.sending
    },
    domProps: {
      "textContent": _vm._s(_vm.sending ? 'Sending...' : 'Send')
    },
    on: {
      "click": function($event) {
        _vm.send()
      }
    }
  }), _vm._v(" "), (_vm.sent) ? _c('span', {
    staticClass: "sent"
  }, [_vm._v("Thanks! Your message was sent.")]) : _vm._e()]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "the-office"
  }, _vm._l((_vm.officeImages), function(image) {
    return _c('div', [_c('img', {
      attrs: {
        "src": image
      }
    })])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('div', {
    staticClass: "contact-info"
  }, [_c('h6', [_vm._v("P:\n                "), _c('a', {
    attrs: {
      "href": "tel:8603503800"
    }
  }, [_vm._v("860-350-3800")])]), _vm._v(" "), _c('address', [_c('h6', [_vm._v("33 Bullet Hill Road, Suite 212 "), _c('br'), _vm._v("\n                    Southbury, CT 06488\n                ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cbc0c16e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contact.vue
// module id = 592
// module chunks = 2